import React from 'react';
import PickXProvincesAndTerritories from "../../components/PickXProvincesAndTerritories/PickXProvincesAndTerritories";
import useResponsibleGamingTextByCountry from "../../hooks/useResponsibleGamingTextByCountry";
import PayoutDistributionTable from "../../components/PayoutDistributionTable/PayoutDistributionTable";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import GlobalConst from "../../constants/GlobalConst";

const TermsOfUseEs = () => {
    const responsibleGamingTexts = useResponsibleGamingTextByCountry();
    const host = window.location.origin;
    return (
        <div className="terms-container">
            <h1>Términos de Uso de TradeFan PickX</h1>
            <p><strong>Última Actualización: 1 de octubre de 2024</strong></p>
            <br/>
            <p>¡IMPORTANTE! LEA DETENIDAMENTE ESTOS TÉRMINOS DE USO DE TRADEFAN PICKX ANTES DE USAR LOS SERVICIOS DE
                TRADEFAN PICKX, YA QUE ESTOS TÉRMINOS AFECTAN SUS DERECHOS Y OBLIGACIONES LEGALES. LOS ACUERDOS (COMO SE
                DEFINEN EN LA SECCIÓN INTRODUCCIÓN) ESTÁN SUJETOS A UNA RENUNCIA AL JUICIO POR JURADO.</p>
            <br/>
            <section id="introduction">
                <p><strong>INTRODUCCIÓN</strong></p>
                <p>
                    TradeFan PickX es un formato de concurso diario de deportes de fantasía ofrecido por 8710031 Canada
                    Inc.
                    (“<strong>TradeFan</strong>”
                    o “<strong>Compañía</strong>”) donde los participantes pueden ganar seleccionando si sus atletas
                    elegidos superarán una proyección estadística durante eventos deportivos del mundo real (“<strong>Pick
                    Set</strong>”). TradeFan es propietario y opera el sitio web <a
                    href={host}>{host}</a> (el “Sitio web”) y, una vez
                    lanzada, la aplicación móvil TradeFan PickX (“<strong>Aplicación móvil</strong>,” y la Aplicación
                    móvil junto con el Sitio web, la “<strong>Plataforma TradeFan</strong>”). Estos Términos de Uso de
                    TradeFan PickX (los “<strong>Términos de Uso</strong>”) rigen todos los aspectos de su acceso y uso
                    de la Plataforma TradeFan; realizar cualquier entrada a través de la Plataforma TradeFan; y los
                    concursos, contenido, productos, funciones, herramientas, promociones y otros servicios ofrecidos a
                    través de la Plataforma TradeFan (colectivamente, los “<strong>Servicios</strong>”).
                </p>
            </section>
            <br/>
            <section id="agreement">
                <p><strong>ACUERDO PARA ESTAR VINCULADO</strong></p>
                <p>
                    Al visitar el Sitio web o descargar la Aplicación móvil, en cada caso, independientemente de si crea
                    o tiene una Cuenta (según se define en la sección Edad y Ubicación Física a continuación),
                    registrarse en los Servicios y/o utilizar los Servicios, acepta estar sujeto a estos Términos de
                    Uso; el aviso de privacidad de TradeFan disponible haciendo clic <a
                    href={host+"/PrivacyPolicy"}>aquí</a>
                    (el “<strong>Aviso de Privacidad</strong>”); y todas las demás reglas, términos y condiciones,
                    políticas y avisos aplicables a la Plataforma TradeFan, los Servicios o cualquier oferta, promoción
                    o bonificación ofrecida en o a través de la Plataforma TradeFan o los Servicios que se publiquen en
                    o a través de la Plataforma TradeFan o los Servicios o que se le comuniquen de otra manera, según
                    puedan ser modificados en cualquier momento, todos los cuales se incorporan por referencia a estos
                    acuerdos en su totalidad (los “Otros Términos”, y junto con los Términos de Uso, los “Acuerdos”).
                    Los Acuerdos no se aplican ni rigen su uso de otros productos y/o servicios proporcionados por
                    TradeFan o sus afiliados, incluidos, entre otros, los concursos de deportes de fantasía de TradeFan
                    Trading.
                </p>
                <p>EN CASO DE QUE NO ACEPTE ESTAR SUJETO A TODOS LOS TÉRMINOS Y CONDICIONES DE LOS ACUERDOS SIN
                    MODIFICACIÓN, NO UTILICE NI ACCEDA A LA PLATAFORMA TRADEFAN O LOS SERVICIOS. Los Acuerdos
                    constituyen un acuerdo legal entre usted y TradeFan y se aplicarán a su acceso y uso de la
                    Plataforma TradeFan y los Servicios, incluso después del cierre de su Cuenta, la terminación de la
                    oferta de los Servicios o la terminación de cualquiera o todos sus derechos otorgados bajo los
                    Acuerdos.</p>
            </section>
            <br/>
            <section id="ageLocation">
                <p><strong>EDAD Y UBICACIÓN FÍSICA</strong></p>
                <p>
                    Para crear una cuenta en la Plataforma TradeFan (“<strong>Cuenta</strong>”), utilizar los Servicios,
                    participar en los concursos ofrecidos a través de los Servicios (los “<strong>Concursos</strong>”),
                    o recibir cualquier premio de la Plataforma TradeFan y/o Servicios, debe tener, y afirma que tiene,
                    al menos dieciocho (18) años. Sin embargo, si se encuentra físicamente en Alabama o Nebraska, debe
                    tener al menos diecinueve (19) años, o si se encuentra en Arizona o Massachusetts, debe tener al
                    menos veintiún (21) años. Puede considerarse un delito penal o civil para cualquier persona utilizar
                    los Servicios o permitir que otros utilicen los Servicios si no cumplen con estos requisitos de
                    edad.
                </p>
                <p>
                    Solo las personas que se encuentren físicamente en las jurisdicciones enumeradas en la Plataforma
                    TradeFan ¿Dónde puedes jugar TradeFan Pick6? (“<strong>Jurisdicciones Elegibles</strong>”) pueden
                    crear una Cuenta y utilizar los Servicios. Estos Términos de Uso incluyen, por referencia, la lista
                    de Jurisdicciones Elegibles disponible en <a href={host+"/#where-is-PickX-available"}>{host}/#where-is-PickX-available</a>
                    TradeFan se reserva el derecho de actualizar, cambiar o modificar estas páginas web o listas de
                    Jurisdicciones Elegibles a su exclusivo criterio, en cualquier momento y sin previo aviso.
                </p>
                <p>
                    Si se encuentra fuera de una Jurisdicción Elegible, es posible que pueda acceder y ver la Plataforma
                    TradeFan, pero tiene prohibido utilizar los Servicios, incluidos los concursos. Si utiliza los
                    Servicios mientras se encuentra fuera de las Jurisdicciones Elegibles, cualquier acción que realice,
                    incluidos los concursos, será nula, y cualquier premio que gane será inválido. Dichos premios serán
                    confiscados y deducidos del saldo de su Cuenta. Si ya ha retirado dichos premios confiscados de su
                    Cuenta, acepta devolverlos de inmediato cuando se lo soliciten.
                </p>
                <p>
                    Estos Términos de Uso rigen su acceso y uso de la Plataforma TradeFan, incluido todo el contenido,
                    cuando acceda o utilice la Plataforma TradeFan desde fuera de las Jurisdicciones Elegibles. También
                    acepta cumplir con todas las leyes aplicables de la jurisdicción en la que se encuentre cuando
                    acceda y/o utilice la Plataforma TradeFan y/o los Servicios.
                </p>
                <p>
                    Al acceder o utilizar los Servicios, usted declara, garantiza y se compromete a que:
                    <ol>
                        <li>
                            <strong>Cumplimiento Jurisdiccional: </strong>Se encuentra en una jurisdicción donde el uso
                            de los Servicios, incluidos los concursos, está permitido por la ley, y ha verificado que su
                            uso de los Servicios cumple con todas las leyes, regulaciones y normas aplicables en su
                            ubicación.
                        </li>
                        <li>
                            <strong>Legalidad de Participación: </strong>Además, declara y garantiza que su uso
                            de los Servicios, incluidos, entre otros, el acceso a la Plataforma, la participación en los
                            Concursos y
                            la recepción de premios, no infringe ninguna restricción legal en su jurisdicción,
                            incluidas, entre otras, las leyes relacionadas con apuestas, juegos de azar, concursos de
                            habilidad o sorteos.
                        </li>
                        <li>
                            <strong>Responsabilidad por el Cumplimiento: </strong>Es su responsabilidad entender
                            y cumplir con las leyes, normas y regulaciones que se apliquen en su jurisdicción. TradeFan
                            no proporciona ni proporcionará ninguna garantía sobre la legalidad de su participación en
                            los Servicios en ninguna jurisdicción.
                        </li>
                        <li>
                            <strong>Restricciones de Acceso: </strong>Si en algún momento se determina que ha accedido
                            o utilizado los Servicios desde una jurisdicción donde dicho acceso o uso está prohibido, o
                            si
                            TradeFan determina, a su exclusivo criterio, que está infringiendo la ley aplicable o estos
                            Acuerdos, TradeFan se reserva el derecho de suspender o terminar de inmediato su Cuenta y el
                            acceso a los Servicios sin previo aviso, y acepta renunciar a cualquier premio o beneficio
                            que haya ganado.
                        </li>
                        <li>
                            <strong>Prueba de Elegibilidad: </strong>A solicitud de TradeFan, acepta proporcionar prueba
                            de su cumplimiento con las leyes y regulaciones de su jurisdicción, incluida la
                            documentación que demuestre su ubicación física y cualquier licencia o autorización que
                            pueda ser necesaria.
                        </li>
                    </ol>
                </p>
            </section>
            <br/>
            <section id="account">
                <p><strong>SU CUENTA</strong></p>
                <p>
                    TradeFan se reserva el derecho de rechazar su solicitud para abrir una Cuenta a su exclusivo
                    criterio, por
                    cualquier razón o sin razón alguna. Cuando cree una Cuenta o utilice los Servicios, es posible que
                    se le solicite
                    proporcionar información específica, incluida, entre otras, su nombre completo legal, fecha de
                    nacimiento,
                    número de seguro social, otro número de identificación fiscal, dirección física, dirección de correo
                    electrónico
                    y cualquier otro detalle o documento necesario para verificar su identidad y elegibilidad. Si
                    TradeFan solicita
                    información adicional, deberá proporcionar de inmediato detalles precisos y completos, y será
                    responsable de
                    actualizarlos según sea necesario. TradeFan puede solicitar más información o documentación en
                    cualquier momento, a su discreción, incluso antes de que participe en un Concurso, realice un
                    depósito o retiro,
                    o reclame un premio. Esto se hace para verificar su identidad y garantizar que cumpla con los
                    criterios de elegibilidad.
                </p>
                <p>
                    Hasta que proporcione la información solicitada, o si no lo hace de inmediato, TradeFan puede, sin
                    limitación, retener premios, restringir su capacidad para realizar depósitos o retiros, suspender su
                    Cuenta, o incluso cerrarla. Acepta permitir que TradeFan verifique su edad e identidad. En caso de
                    dudas, disputas o inquietudes sobre su identidad o elegibilidad, TradeFan puede utilizar cierta
                    información recopilada de usted a su discreción para ayudar a verificar estos detalles.
                </p>
                <p>
                    Solo se le permite crear una Cuenta. No puede utilizar ni acceder a la Cuenta de otra persona, con
                    o sin su consentimiento, ni permitir que alguien utilice o acceda a su Cuenta. Esto incluye, pero
                    no se limita a, participar en Concursos en nombre de otra persona, usar la Cuenta de otra persona
                    para
                    Concursos, acceder a los detalles del Pick Set, Concurso o Cuenta de otra persona, o permitir que
                    alguien
                    más haga alguna de estas cosas con su Cuenta. Si TradeFan cree, por cualquier motivo, que ha abierto
                    más de una Cuenta, ha permitido que otra persona acceda a su Cuenta o está utilizando la Cuenta de
                    otra persona, TradeFan se reserva el derecho de suspender o cancelar cualquiera o todas sus Cuentas.
                    También
                    puede cancelar cualquier participación pendiente en el Concurso o retener, revocar o cancelar
                    cualquier premio
                    otorgado.
                </p>
                <p>
                    Estos Términos de Uso también se aplican si accede a la Cuenta de otra persona, incluso si no tiene
                    su
                    propia Cuenta. Dicho acceso se considerará una violación de los Términos. No puede abrir una Cuenta
                    en
                    nombre de otra persona, especialmente si esa persona tiene prohibido por ley o por estos Términos
                    abrir una
                    Cuenta o utilizar los Servicios.
                </p>
                <p>
                    Al utilizar los Servicios, acepta que TradeFan, sus afiliados y proveedores de servicios externos
                    pueden supervisar y registrar sus comunicaciones y ubicación geográfica. También acepta que TradeFan
                    informe la actividad de su Cuenta o las ganancias de premios a las autoridades estatales, federales
                    y locales pertinentes, en cumplimiento con las leyes aplicables.
                </p>
            </section>
            <br/>
            <section id="loginPassword">
                <p><strong>INICIO DE SESIÓN Y CONTRASEÑA DE LA CUENTA</strong></p>
                <p>
                    Usted es responsable de mantener la confidencialidad de su nombre de inicio de sesión y contraseña
                    de la Cuenta, y no debe compartirlos con nadie. Acepta hacer todo lo posible para proteger sus datos
                    de inicio de sesión, incluido el uso de una contraseña única para su Cuenta y desactivar cualquier
                    opción del navegador que almacene o complete automáticamente las contraseñas. También debe cambiar
                    su contraseña regularmente, y puede encontrar instrucciones para hacerlo [aquí]. Además, debe
                    bloquear los dispositivos que utiliza para acceder a la Plataforma TradeFan.
                </p>
                <p>
                    Usted es responsable de todas las acciones, cargos y daños que ocurran bajo su Cuenta, ya sea que
                    estén autorizados por usted o no. Si cree que alguien más está utilizando su Cuenta, contáctenos de
                    inmediato en support@TradeFan.com. TradeFan no se hace responsable de las pérdidas, cargos o daños
                    debido a un acceso no autorizado a su Cuenta o su falta de notificación de dicho acceso no
                    autorizado, independientemente de si estaba al tanto de ello.
                </p>
                <p>
                    Usted acepta indemnizar y eximir de responsabilidad a TradeFan, sus empresas matrices, subsidiarias,
                    afiliadas, sucesores, cesionarios, funcionarios, directores, empleados, agentes, contratistas,
                    accionistas y representantes (colectivamente, las “Partes Exoneradas de TradeFan”) de cualquier
                    reclamo, acción legal, responsabilidades, costos, pérdidas y gastos (incluidos los honorarios de
                    abogados, los costos judiciales y otros gastos legales). Esto incluye costos derivados de juicios,
                    apelaciones o procedimientos de bancarrota, así como cualquier daño resultante del acceso de
                    terceros a su Cuenta, ya sea que dicho acceso esté autorizado o no, y ya sea debido a su violación
                    de las leyes, negligencia, acciones deliberadas o incumplimiento de estos Acuerdos.
                </p>
            </section>
            <br/>
            <section id="deposits">
                <p><strong>DEPÓSITOS</strong></p>
                <p>
                    Su Cuenta puede financiarse a través de varios métodos de depósito, dependiendo de su ubicación
                    física al realizar el depósito. TradeFan acepta las principales tarjetas de débito y, según su
                    ubicación, también puede aceptar las principales tarjetas de crédito.
                </p>
                <p>
                    Usted confirma que es el propietario legal del método de pago utilizado para depósitos y retiros y
                    que los fondos no están relacionados con ninguna actividad ilegal. Utilizar un método de pago que no
                    posea legalmente o depositar fondos vinculados a una actividad ilegal viola estos Términos de Uso.
                </p>
                <p>
                    Usted acepta no revertir (o “devolver”) ningún depósito realizado en su Cuenta, incluidos los
                    realizados a través de terceros. Si algún depósito es devuelto, cancelado, no se liquida o no es
                    honrado por su institución financiera, TradeFan puede restringir de inmediato el acceso a su Cuenta.
                    Cualquier premio, recompensa, crédito o bonificación relacionado con estos depósitos será invalidado
                    y deducido del saldo de su Cuenta. También acepta devolver cualquier fondo que haya retirado que
                    esté asociado con un depósito cancelado o devuelto.
                </p>
                <p>
                    Si su depósito es devuelto o cancelado, o no se liquida, TradeFan se reserva el derecho de (i)
                    deducir el monto del depósito de su Cuenta, (ii) suspender o cerrar su Cuenta y/o (iii) recuperar
                    los fondos por cualquier otro medio, como utilizar una agencia de cobros (lo que puede afectar
                    negativamente su puntaje crediticio). Usted es responsable de reembolsar a TradeFan cualquier costo,
                    tarifa o penalización relacionada con devoluciones o depósitos cancelados, incluidos honorarios
                    legales y gastos por esfuerzos de cobro.
                </p>
                <p>
                    Si cree que sus fondos han sido mal manejados, puede presentar una queja enviando un correo
                    electrónico a <a href="mailto:support@TradeFan.com"> support@TradeFan.com</a>. TradeFan intentará
                    responder a su queja dentro de diez (10) días hábiles. Si la queja no se resuelve a su favor,
                    TradeFan explicará las razones. Si se necesita más información para procesar su queja, TradeFan le
                    informará sobre los detalles adicionales requeridos.
                </p>
            </section>
            <br/>
            <section id="conditionsParticipation">
                <p><strong>CONDICIONES DE PARTICIPACIÓN</strong></p>
                <p>
                    No se le permite utilizar la Plataforma TradeFan o sus servicios, incluidos los concursos, si se
                    aplica cualquiera de los siguientes casos:
                </p>
                <ul>
                    <li>Las leyes, normas, regulaciones u otros actos autorizados de la jurisdicción en la que se
                        encuentra físicamente no permiten que utilice los Servicios.
                    </li>
                    <li>Su uso infringe las reglas de la Plataforma TradeFan.</li>
                    <li>Ha accedido a información confidencial o no publicada que le da una ventaja injusta,
                        como conocer el resultado de los eventos o detalles privados de un organismo rector deportivo.
                    </li>
                    <li>Usted o un familiar inmediato (alguien que viva con usted, como pareja, padre o hermano)
                        (un “Familiar Inmediato”) trabaja para una compañía de deportes de fantasía o un sitio similar
                        que ofrezca tarifas de inscripción o premios.
                    </li>
                    <li>Está en una lista de exclusión estatal para deportes de fantasía diarios o juegos de azar.</li>
                    <li>TradeFan decide que su participación socava la equidad de cualquier concurso.</li>
                    <li>Su participación infringe alguna norma establecida por su empleador u organización deportiva,
                        como las reglas
                        sobre la aceptación de premios.
                    </li>
                    <li>Un tribunal o organismo regulador le ha prohibido utilizar el servicio, o utilizarlo infringe
                        cualquier ley o regulación en su área.
                    </li>
                </ul>
                <p>
                    No puede utilizar la Plataforma TradeFan o los servicios para ningún juego, partido o evento
                    administrado por una organización deportiva con la que esté relacionado si es atleta, jugador,
                    agente, entrenador, árbitro, propietario del equipo o cualquier otro oficial (como un médico o
                    entrenador) que trabaje con el equipo. Esto también se aplica si es empleado, consultor, contratista
                    o Familiar Inmediato de cualquiera de estas personas.
                </p>
                <p>
                    Los empleados de TradeFan y sus Familiares Inmediatos no pueden participar en concursos públicos
                    (excepto para pruebas). Sin embargo, pueden jugar en concursos privados, incluidos aquellos
                    organizados por TradeFan, por dinero en efectivo u otros premios. Un ‘Concurso Privado’ es uno que
                    no aparece en la lista pública en la plataforma TradeFan y es organizado por otro empleado de
                    TradeFan o sus familiares, amigos o parientes.
                </p>
                <p>
                    TradeFan puede suspender su cuenta, eliminarlo de los concursos, retener premios o solicitar la
                    devolución de premios si descubren o creen que violó sus reglas. Ellos tienen la última palabra en
                    esto y no necesitan una razón específica. Las violaciones incluyen:
                </p>
                <ul>
                    <li>Cometer fraude, como manipular Concursos o Pick Sets, hacer trampa, fraude financiero o
                        uso no autorizado de créditos.
                    </li>
                    <li>Actuar de manera que sea injusta, perjudicial para los Servicios de TradeFan o negativa para
                        otros usuarios.
                    </li>
                    <li>Hacer cualquier cosa que dañe la reputación de TradeFan o perjudique su negocio.</li>
                    <li>Intentar influir en los resultados de los juegos o Concursos de manera injusta, ya sea solo o
                        con otros.
                    </li>
                    <li>Trabajar con otros para manipular Pick Sets o Concursos.</li>
                    <li>Utilizar herramientas automáticas como bots o scripts para interactuar con la Plataforma
                        TradeFan, participar en concursos o recopilar datos.
                    </li>
                    <li>Aprovecharse de retrasos en la actualización de información o estadísticas.</li>
                    <li>Utilizar la Plataforma TradeFan para algo que no sea uso personal o compartirla con otros con
                        fines comerciales.
                    </li>
                    <li>Abusar de bonificaciones, programas de referencia o promociones.</li>
                    <li>Aprovechar errores obvios o fallos en el sistema.</li>
                    <li>Alterar, eludir o manipular los sistemas, la seguridad o los controles de riesgo de TradeFan.
                    </li>
                    <li>Recopilar información de otros usuarios con cualquier propósito.</li>
                </ul>
            </section>
            <br/>
            <section id="contestEntry">
                <p><strong>ENTRADA A CONCURSOS</strong></p>
                <p>Es importante que lea y comprenda las reglas y procedimientos para cualquier concurso en el que
                    participe. Estas reglas, incluidas las actualizaciones que se realicen, se incorporan en su
                    totalidad a estos Términos de Uso por referencia. Puede encontrar más detalles en la pestaña Reglas
                    del Concurso en la página del concurso o en la sección TradeFan PickX del Centro de Ayuda/FAQ. Estas
                    se incorporan en su totalidad a estos Términos de Uso por referencia, incluidas las enmiendas
                    realizadas en cualquier momento. TradeFan y sus partes relacionadas no son responsables si participa
                    en un concurso sin comprender completamente las reglas y procedimientos.</p>
                <p>
                    La participación en cada Concurso debe hacerse solo como se especifica en los Acuerdos. TradeFan
                    Pick-X es un
                    concurso donde los participantes pueden ganar seleccionando si sus atletas elegidos superarán
                    una proyección estadística durante eventos deportivos del mundo real. En Pick-X, los participantes
                    pueden construir alineaciones de entre 3 y 8 jugadores. Ingrese sus selecciones para competir en
                    concursos y ganar premios en efectivo acertando la cantidad requerida de selecciones correctas.
                    Después de crear su Pick Set, deberá ingresar la tarifa total de entrada con la que desea jugar.
                    Puede hacer esto escribiendo directamente el monto total en dólares. Las tarifas de entrada deben
                    ser en montos enteros. Cuando esté listo, proceda a la pantalla de finalización para revisar su Pick
                    Set y los montos estimados de premios antes de enviarlo.
                </p>
                <p>
                    Los Pick Sets se crean eligiendo apuestas de una selección de opciones disponibles. Antes de
                    finalizar un Pick Set, TradeFan verificará que todos los juegos incluidos no hayan comenzado. Si
                    alguno de los juegos ya ha comenzado, el Pick Set no se activará. Cada Pick Set debe incluir
                    jugadores de dos equipos diferentes. Solo puede seleccionar un jugador una vez, y debe realizar
                    selecciones de jugadores de al menos dos (2) equipos diferentes. Una vez que se elige un jugador, no
                    se puede volver a seleccionar en el mismo Pick Set. Una vez que se ha enviado el Pick Set, las
                    entradas no se pueden editar ni
                    retirar.
                </p>
                <p>
                    TradeFan puede negarse a aceptar cualquier entrada a Concurso, cualquier parte de una entrada a
                    Concurso, prohibirle la entrada a cualquier Concurso o prohibirle el uso de la Plataforma TradeFan o
                    los Servicios, en cada caso, por cualquier razón o sin razón, a discreción exclusiva y absoluta de
                    TradeFan. Además, antes de que comience un Concurso, TradeFan puede cancelar cualquier Concurso(s)
                    y/o cualquier selección disponible para crear su Pick Set a discreción exclusiva y absoluta de
                    TradeFan, por cualquier razón o sin razón.
                </p>
                <p>En caso de que su Pick Set se ingrese correctamente en un Concurso(s), por cada Concurso en el que se
                    ingrese correctamente su Pick Set, se debitará un dólar estadounidense ($1.00) de su saldo de
                    Cuenta. En caso de que tenga fondos insuficientes en su Cuenta, incluidos, entre otros, si no se ha
                    recibido un depósito por parte de TradeFan antes de realizar la entrada al Concurso (por ejemplo, un
                    depósito todavía está siendo procesado por el procesador de pagos), dicha entrada puede ser anulada
                    por TradeFan a su discreción exclusiva y absoluta, por cualquier razón o sin razón. Una entrada al
                    Concurso no es válida hasta que la entrada al Concurso sea aceptada por los servidores de TradeFan,
                    incluso en el caso de que dicha entrada aparezca en su sección Mis Selecciones. Usted es responsable
                    de asegurarse de que todos los detalles y selecciones de su Pick Set y entrada al Concurso estén
                    completos
                    y correctos antes de enviarlos.
                </p>
                <p>
                    Las selecciones solo son elegibles para ser calificadas como Correctas si el jugador seleccionado
                    cumple con los requisitos mínimos de juego, independientemente de si selecciona Más o Menos para esa
                    selección.
                </p>
                <p>
                    Si se espera que un jugador no juegue, TradeFan puede hacer que ese jugador no esté disponible para
                    selección. Si un jugador no termina jugando, sus selecciones serán calificadas como selecciones
                    anuladas, su Pick Set será anulado y se reembolsará su tarifa de entrada para ese Pick Set.
                </p>
                <p>
                    Si ingresa a un Concurso en circunstancias sospechosas, según lo determine TradeFan a su discreción
                    exclusiva y absoluta, por cualquier razón o sin razón, como infringir los Acuerdos, participar en
                    demasiados Concursos, realizar selecciones de Pick Set interconectadas o ingresar a Concursos en un
                    patrón inusual, TradeFan puede suspender su Cuenta, anular sus entradas a Concursos o retener
                    premios. Usted acepta proporcionar de inmediato cualquier información o cooperación solicitada por
                    TradeFan al investigar actividades sospechosas. Si no lo hace, acepta renunciar y devolver todos los
                    premios asociados.
                </p>
                <p>
                    Al ingresar a un Concurso o utilizar los Servicios o la Plataforma TradeFan, acepta seguir las
                    decisiones de TradeFan, que se toman a su exclusivo y absoluto criterio, por cualquier razón o sin
                    razón, y son definitivas. Entiende que no tiene derecho inherente a utilizar la Plataforma TradeFan
                    o los Servicios, y que TradeFan puede suspender o cancelar su Cuenta en cualquier momento, por
                    cualquier razón. TradeFan puede rechazar su uso de la Plataforma TradeFan, Servicios o cualquier
                    Servicio específico, y puede rechazar entradas a Concursos, a su exclusivo y absoluto criterio. Si
                    se involucra en conductas que TradeFan considere inapropiadas, fraudulentas, sospechosas, engañosas,
                    deshonestas o injustas, TradeFan puede suspender o cancelar su Cuenta, anular entradas, retener
                    premios o exigir la devolución de premios. Las Partes Exoneradas de TradeFan no son responsables de
                    estas acciones, ni impiden que TradeFan emprenda acciones legales.
                </p>
                <p>
                    SI UN CONCURSO NO PUEDE PROSEGUIR SEGÚN LO PLANIFICADO DEBIDO A PROBLEMAS TÉCNICOS, MANIPULACIÓN,
                    FRAUDE U OTRAS CAUSAS, TRADEFAN, A SU DISCRECIÓN EXCLUSIVA Y ABSOLUTA, PUEDE CANCELAR, TERMINAR,
                    MODIFICAR O SUSPENDER EL CONCURSO. CUALQUIER INTENTO DE DAÑAR EL SITIO WEB O SOCAVAR LA OPERACIÓN
                    LEGÍTIMA DE UN CONCURSO PUEDE VIOLAR LAS LEYES, Y TRADEFAN SE RESERVA EL DERECHO DE BUSCAR DAÑOS Y
                    OTROS RECURSOS HASTA EL MÁXIMO PERMITIDO POR LA LEY.
                </p>
            </section>
            <br/>
            <section id="contestWithdrawal">
                <p><strong>RETIRADA DEL CONCURSO</strong></p>
                <p>
                    Es posible que pueda retirarse de los Concursos bajo ciertas circunstancias, según lo determine
                    TradeFan a su discreción exclusiva y absoluta, por cualquier razón o sin razón. Para obtener más
                    información sobre la retirada de los Concursos y cuándo se permitirá o no la retirada de los
                    Concursos, consulte la sección TradeFan PickX del Centro de Ayuda de TradeFan disponible haciendo
                    clic <a href="/help">aquí</a>, que se incorpora en su totalidad a estos Términos de Uso por
                    referencia, incluidas las enmiendas realizadas en cualquier momento.
                </p>
            </section>
            <br/>
            <section id="limitationResposibilities">
                <p><strong>LIMITACIÓN DE LAS RESPONSABILIDADES DE TRADEFAN</strong></p>
                <p>
                    Las Partes Exoneradas de TradeFan (como se definen aquí) no son responsables de ninguna información
                    incorrecta, inválida o inexacta; entradas incompletas, incorrectas, ilegibles, no deseadas o mal
                    dirigidas; errores humanos; retrasos postales o correo con franqueo debido; fallos o mal
                    funcionamiento técnicos, como cortes de servicios públicos, teléfono o Internet; omisiones,
                    interrupciones, eliminaciones o defectos en los sistemas telefónicos o de Internet, sistemas
                    informáticos, datos, servidores, proveedores o software (incluidos software o sistemas operativos
                    que le impiden utilizar la Plataforma TradeFan o participar en un Concurso); cualquier daño a su
                    computadora o equipo de otra persona debido al uso de la Plataforma TradeFan o Servicios; la
                    incapacidad de acceder o utilizar los Servicios o cualquier página web relacionada con el Sitio web
                    o la Plataforma TradeFan; problemas como robos, manipulación o acceso no autorizado o cambios en la
                    Plataforma TradeFan o su Cuenta; datos que se procesan tarde, incorrectamente o se pierden debido a
                    problemas telefónicos, de Internet o postales, fallos de computadoras o congestión del tráfico; o
                    cualquier error tipográfico, de impresión o similar.
                </p>
                <p>
                    TradeFan, a su discreción exclusiva y absoluta, puede suspender o cancelar cualquier Servicio,
                    Concurso o la Plataforma TradeFan, así como suspender su acceso, cancelar su Cuenta, anular entradas
                    a Concursos, retener premios o solicitar la devolución de premios o fondos acreditados por error a
                    su Cuenta, incluso si ya los ha retirado, por cualquier razón o sin razón. Esto puede ocurrir si:
                </p>
                <ul>
                    <li>Hay un error obvio en un Concurso, como estadísticas incorrectas o si el evento ya ha
                        comenzado u ocurrido.
                    </li>
                    <li>Una selección se califica incorrectamente a su favor.</li>
                    <li>Los fondos se acreditan por error en su Cuenta.</li>
                    <li>Un virus, error, manipulación o fallo técnico detiene el funcionamiento adecuado de la
                        Plataforma TradeFan o Servicios o afecta la equidad e integridad de la Plataforma TradeFan,
                        Concursos o Servicios.
                    </li>
                </ul>
                <p>
                    Debe informar de inmediato a TradeFan y dejar de utilizar los Servicios y la Plataforma si se entera
                    de
                    cualquier error relacionado con los Servicios, Plataforma, Concursos o su Cuenta, incluidos los
                    fondos acreditados por error a su Cuenta. Cualquier cantidad o premio acreditado por error a su
                    Cuenta se mantiene en fideicomiso para TradeFan y debe devolverse cuando se lo soliciten, incluso si
                    ya los ha retirado. TradeFan también se reserva el derecho de reclamar cualquier fondo o premio
                    acreditado por error directamente de su Cuenta.
                </p>
                <p>
                    CUALQUIER INTENTO POR PARTE DE USTED O CUALQUIER OTRA PERSONA DE DAÑAR LA PLATAFORMA TRADEFAN O LOS
                    SERVICIOS O SOCAVAR SU OPERACIÓN LEGÍTIMA ES UNA VIOLACIÓN DE ESTOS TÉRMINOS DE USO Y PUEDE VIOLAR
                    TAMBIÉN LAS LEYES PENALES Y/O CIVILES. SI SE HACE TAL INTENTO, TRADEFAN SE RESERVA EL DERECHO DE
                    BUSCAR DAÑOS Y OTROS RECURSOS HASTA EL MÁXIMO PERMITIDO POR LA LEY.
                </p>
                <p>
                    Solo puede utilizar la Plataforma TradeFan y los Servicios como se especifica en los Acuerdos. El
                    incumplimiento
                    de los Acuerdos puede resultar, sin limitación, en la suspensión y/o cancelación de su Cuenta, la
                    anulación o cancelación de cualquier entrada pendiente en el Concurso, la retención de cualquier
                    premio
                    y/o la devolución de cualquier premio.
                </p>
            </section>
            <br/>
            <section id="howPick12Works">
                <p><strong>¿CÓMO FUNCIONA UN CONCURSO PICK-12?</strong></p>
                <p>
                    Responda correctamente tantas preguntas de más/menos de las 12 posibles, y consulte el siguiente
                    esquema de premios para reclamar el premio correspondiente a su puntaje:
                </p>
                <PayoutDistributionTable payoutInfos={new Pick12PayoutCalculator().calculateDistribution(5)}
                                         currency={GlobalConst.SITE_CURRENCY}/>
            </section>
            <br/>
            <section id="howPick16Works">
                <p><strong>¿CÓMO FUNCIONA UN CONCURSO PICK-16?</strong></p>
                <p>
                    Responda correctamente tantas preguntas de más/menos de las 16 posibles, y consulte el siguiente
                    esquema de premios para reclamar el premio correspondiente a su puntaje:
                </p>
                <PayoutDistributionTable payoutInfos={new Pick16PayoutCalculator().calculateDistribution(5)}
                                         currency={GlobalConst.SITE_CURRENCY}/>
            </section>
            <br/>
            <section id="grantOfLicense">
                <p><strong>CONCESIÓN DE LICENCIA</strong></p>
                <p>
                    Excepto donde lo prohíba la ley, al utilizar los Servicios o la Plataforma TradeFan, participar en
                    cualquier Concurso
                    o aceptar cualquier premio, otorga a TradeFan y sus afiliados el derecho mundial, perpetuo,
                    irrevocable, a nivel empresarial, libre de regalías para usar su nombre, nombre de usuario,
                    fotografía, imagen, declaraciones, información biográfica, voz, ciudad y estado de residencia y otra
                    información identificativa en cualquier forma de medios, conocidos o futuros, con fines
                    publicitarios y promocionales relacionados con la Plataforma TradeFan, los Servicios, TradeFan o sus
                    afiliados y/o TradeFan y otros productos y servicios de los afiliados de TradeFan sin compensación,
                    notificación, revisión, aprobación o permiso adicional. Usted acepta firmar cualquier autorización
                    publicitaria requerida por TradeFan.
                </p>
            </section>
            <br/>
            <section id="promotions">
                <p><strong>PROMOCIONES</strong></p>
                <p>
                    Excepto donde lo prohíba la ley, al utilizar los Servicios o la Plataforma TradeFan, participar en
                    cualquier Concurso
                    o aceptar cualquier premio, otorga a TradeFan y sus afiliados el derecho mundial, perpetuo,
                    irrevocable, a nivel empresarial, libre de regalías para usar su nombre, nombre de usuario,
                    fotografía, imagen, declaraciones, información biográfica, voz, ciudad y estado de residencia y otra
                    información identificativa en cualquier forma de medios, conocidos o futuros, con fines
                    publicitarios y promocionales relacionados con la Plataforma TradeFan, los Servicios, TradeFan o sus
                    afiliados y/o TradeFan y otros productos y servicios de los afiliados de TradeFan sin compensación,
                    notificación, revisión, aprobación o permiso adicional. Usted acepta firmar cualquier autorización
                    publicitaria requerida por TradeFan.
                </p>
                <p>
                    Los Acuerdos se aplican a cualquier promoción, bonificación, logro u oferta similar relacionada con
                    los Servicios y/o la Plataforma TradeFan. Cada promoción, bonificación, misión u oferta similar
                    puede incluir términos, condiciones, reglas y/o requisitos de elegibilidad adicionales. Estos se
                    publicarán en la Plataforma TradeFan y/o los Servicios y serán vinculantes de inmediato, ya sea que
                    se le comuniquen directamente o no, o se le comuniquen de otra manera. Estos términos, condiciones,
                    reglas y/o requisitos de elegibilidad adicionales se incorporan en su totalidad a estos Términos de
                    Uso por referencia, incluidas las futuras modificaciones.
                </p>
                <p>
                    Al participar en cualquier promoción, bonificación, logro u oferta similar, o al reclamar o aceptar
                    cualquier premio o recompensa, acepta todos los términos, condiciones, reglas y/o requisitos de
                    elegibilidad de esa oferta, que también se incorporan en estos Términos de Uso por referencia,
                    incluidas las enmiendas. Si no está de acuerdo con los términos, condiciones, reglas y/o requisitos
                    de elegibilidad, no participe ni acepte ningún premio o recompensa.
                </p>
                <p>
                    En caso de cualquier conflicto entre estos Acuerdos y los términos separados de una promoción
                    específica, bonificación, logro u oferta similar, prevalecerán los términos específicos de la
                    promoción u oferta. Nada en los Acuerdos cambiará o invalidará esos términos separados.
                </p>
                <p>
                    TradeFan se reserva el derecho de evitar que participe en cualquier promoción, bonificación, logro u
                    oferta similar por cualquier razón o sin razón, a su exclusivo y absoluto criterio. Usted es
                    totalmente responsable de leer y comprender los términos, condiciones y requisitos de cualquier
                    promoción en la que participe.
                </p>
            </section>
            <br/>
            <section id="responsibleGaming">
                <p><strong>JUEGO RESPONSABLE</strong></p>
                <p>
                    Información sobre el juego responsable, incluidas las opciones de autoexclusión y autolimitación,
                    está
                    disponible en: <a href={`${responsibleGamingTexts.link}`}>{responsibleGamingTexts.title}</a>
                </p>
            </section>
            <br/>
            <section id="statisticsAndLiveScoring">
                <p>
                    Todas las estadísticas, resultados, noticias y otra información proporcionada en la Plataforma
                    TradeFan o Servicios, incluidas las estadísticas "en vivo", son no oficiales, pueden no estar
                    actualizadas y se proporcionan TAL COMO ESTÁN con fines informativos y de entretenimiento
                    únicamente. No debe confiar en estas estadísticas, resultados, noticias u otra información para
                    ningún propósito, incluidas las decisiones de Concurso o Pick Set. Estas estadísticas y resultados
                    también pueden diferir de los oficiales utilizados para determinar el resultado de las selecciones
                    de Pick Set y/o Concursos.
                </p>
                <p>
                    Ni las Partes Exoneradas de TradeFan ni ningún proveedor externo garantizan ni hacen
                    representaciones sobre la exactitud o fiabilidad de las estadísticas, resultados, noticias u otra
                    información proporcionada a través de la Plataforma TradeFan, los Servicios o fuentes relacionadas.
                    Las Partes Exoneradas de TradeFan y los proveedores externos no son responsables de la exactitud,
                    utilidad o disponibilidad de esta información y no serán responsables de ningún error u omisión en
                    las estadísticas, noticias, resultados u otra información proporcionada.
                </p>
            </section>
            <br/>
            <section id="results">
                <p><strong>RESULTADOS</strong></p>
                <p>
                    Los concursos ofrecidos a través de los Servicios y/o la Plataforma TradeFan son concursos de
                    habilidad. Los ganadores se determinan en función de la habilidad y el conocimiento del
                    participante, incluido, sin limitación, en relación con la información deportiva relevante y las
                    reglas del Concurso. Los Servicios, la Plataforma TradeFan y/o los Concursos no se pueden utilizar
                    para ninguna forma de apuestas ilícitas.
                </p>
                <p>
                    Los concursos se puntúan en función del número de selecciones correctas en su Pick Set para ese
                    Concurso. Los resultados de los concursos se basan en las estadísticas y puntuaciones finales al
                    finalizar los juegos, concursos, partidos o eventos asociados con el Concurso. Al finalizar el
                    último juego, concurso, partido o evento asociado con el Concurso, se revisan los resultados, se
                    califican las entradas y se otorgan los premios. Los resultados de las puntuaciones finales y las
                    estadísticas no se cambiarán, independientemente de cualquier ajuste oficial de las estadísticas o
                    puntuaciones realizado más tarde, excepto a discreción exclusiva y absoluta de TradeFan, por
                    cualquier razón o sin razón. En el caso de que se cancele, posponga o reprograme un juego(s),
                    concurso(s), partido(s) o evento(s) asociado con un Concurso, para los fines del Concurso, dicha
                    cancelación, aplazamiento o reprogramación se tratará de acuerdo con las Reglas del Concurso para el
                    Concurso aplicable (disponible en la pestaña Reglas del Concurso de la página de Detalles del
                    Concurso aplicable), que se incorpora en su totalidad a estos Términos de Uso por referencia,
                    incluidas las enmiendas realizadas en cualquier momento.
                </p>
            </section>
            <br/>
            <section id="paymentAndWithdrawal">
                <p><strong>PAGO Y RETIRO</strong></p>
                <p>
                    Antes de entregarle cualquier premio, TradeFan puede solicitarle que complete una declaración jurada
                    que confirme su elegibilidad y libere a TradeFan de cualquier reclamo. También deberá confirmar que
                    es elegible para utilizar los Servicios, cumplir con los Acuerdos y proporcionar documentación que
                    pruebe su identidad y elegibilidad, incluidos formularios de impuestos completados. Si TradeFan
                    solicita esto y no lo proporciona dentro de siete (7) días, o si TradeFan determina que no cumple
                    con los requisitos o no sigue los Acuerdos, pueden retener o recuperar cualquier premio, y pueden
                    suspender o cancelar su Cuenta y el acceso a los Servicios.
                </p>
                <p>
                    Sujeto a que TradeFan verifique su cumplimiento con los Acuerdos y cualquier otra condición de
                    participación, las ganancias de su Pick Set se procesarán después de que ambos de los siguientes
                    hayan ocurrido:
                </p>
                <ol>
                    <li>
                        Se haya completado cada juego en el Pick Set, lo que puede incluir juegos para los que no tenga
                        selecciones; y
                    </li>
                    <li>
                        TradeFan haya finalizado las estadísticas de cada juego en el Pick Set para confirmar su
                        exactitud con la puntuación oficial de las respectivas ligas, generalmente al final de la noche.
                    </li>
                </ol>
                <p>
                    Debido a esto, puede haber un tiempo entre cuando sus selecciones hayan finalizado y cuando se
                    procesen las ganancias en su cuenta.
                </p>
                <p>
                    Todos los impuestos asociados con la recepción de cualquier premio son responsabilidad exclusiva del
                    ganador.
                    TradeFan puede reportar los premios a la agencia estatal aplicable y/o al Servicio de Impuestos
                    Internos y/o
                    retener una parte de sus premios según el monto bruto o neto ganado. TradeFan remitirá cualquier
                    parte de sus premios retenidos con fines fiscales al Servicio de Impuestos Internos y/o a la agencia
                    estatal aplicable en cumplimiento de la ley aplicable.
                </p>
                <p>
                    Para actualizar su información de contacto, puede editarla dentro de su Cuenta o solicitar cambios
                    enviando un correo electrónico a <a href='mailto:support@TradeFan.com'>support@TradeFan.com</a>
                </p>
                <p>
                    En caso de que la concesión de cualquier premio sea impugnada por cualquier autoridad legal,
                    TradeFan se reserva el derecho de determinar, a su exclusivo y absoluto criterio, por cualquier
                    razón o sin razón, si otorga o no dicho premio. En caso de que gane una cantidad o premio superior a
                    un cierto valor, y deba ciertas cantidades al estado, incluidos, entre otros, atrasos de manutención
                    infantil o impuestos no pagados, TradeFan puede suspender su Cuenta, evitar que realice retiros de
                    su Cuenta y/o retener y remitir cualquier premio, o parte de este, de acuerdo con la ley aplicable.
                    No se permite la sustitución o transferencia de ningún premio, excepto que TradeFan se reserva el
                    derecho, a su exclusivo y absoluto criterio, por cualquier razón o sin razón, de sustituir un premio
                    de igual o mayor valor. Todos los premios se otorgan "tal como están" y sin garantía de ningún tipo,
                    expresa o implícita, incluidas, entre otras, cualquier garantía implícita de comerciabilidad o uso
                    para un propósito particular.
                </p>
            </section>
            <br/>
            <section id="termination">
                <p><strong>TERMINACIÓN Y EFECTO DE LA TERMINACIÓN</strong></p>
                <p>
                    Puede cerrar permanentemente su Cuenta en cualquier momento por cualquier razón enviando un correo
                    electrónico a <a
                    href='mailto:support@TradeFan.com'>support@TradeFan.com</a>
                </p>
                <p>
                    TradeFan puede suspender o terminar de inmediato los Servicios, Concursos, Plataforma TradeFan o
                    cualquier
                    función o función dentro de los Servicios o Plataforma en cualquier momento, sin previo aviso, a su
                    exclusivo
                    y absoluto criterio, por cualquier razón o sin razón. Si TradeFan termina los Servicios, pueden
                    reembolsar el saldo de su Cuenta menos cualquier bonificación no utilizada, entradas gratuitas o
                    créditos promocionales, que se perderán.
                </p>
                <p>
                    Además, TradeFan puede, sin previo aviso y a su exclusivo criterio, por cualquier razón o sin razón,
                    cerrar su Cuenta, desactivar su(s) contraseña(s), denegarle el acceso a la Plataforma TradeFan y los
                    Servicios, cancelar cualquier participación pendiente en el Concurso y/o terminar cualquier derecho
                    otorgado bajo los Acuerdos. Si esto ocurre, debe dejar de utilizar de inmediato la Plataforma
                    TradeFan y los Servicios. Las Partes Exoneradas de TradeFan no son responsables de ninguna
                    suspensión o terminación de los Servicios, Concursos, la Plataforma TradeFan o cualquier
                    característica, ni de la terminación o suspensión de su Cuenta.
                </p>
                <p>
                    El cierre de su Cuenta o la terminación de los Servicios, Concursos o Plataforma, o cualquier
                    derecho otorgado bajo los Acuerdos, no afecta ningún derecho, obligación o responsabilidad que
                    surgió antes de eso. Todas las partes de los Acuerdos que deben continuar después del cierre de su
                    Cuenta o la terminación de los Servicios o derechos, como las disposiciones de propiedad, exenciones
                    de garantía, indemnización y limitación de responsabilidad, seguirán vigentes.
                </p>
            </section>
            <br/>
            <section id="disclaimer">
                <p><strong>RENUNCIA DE GARANTÍAS</strong></p>
                <p>
                    TODO EL CONTENIDO, SOFTWARE Y FUNCIONES EN LA PLATAFORMA TRADEFAN, CONCURSOS Y SERVICIOS SE
                    PROPORCIONAN "TAL COMO ESTÁN", "SEGÚN DISPONIBILIDAD" Y "CON TODOS LOS DEFECTOS". SU USO DE LA
                    PLATAFORMA TRADEFAN Y LA PARTICIPACIÓN EN CUALQUIER CONCURSO ES BAJO SU PROPIO RIESGO. LAS PARTES
                    EXONERADAS DE TRADEFAN RENUNCIAN A CUALQUIER Y TODAS LAS GARANTÍAS, YA SEAN EXPRESAS O IMPLÍCITAS,
                    INCLUIDAS LAS DE NO INFRACCIÓN, COMERCIABILIDAD, APTITUD PARA UN PROPÓSITO PARTICULAR Y TITULARIDAD.
                </p>
                <p>
                    LAS PARTES EXONERADAS DE TRADEFAN NO HACEN GARANTÍAS ACERCA DE:
                </p>
                <ul>
                    <li>LA PROPIEDAD INTELECTUAL, PLATAFORMA, CONCURSOS O SERVICIOS.</li>
                    <li>LA EXACTITUD O COMPLETITUD DEL CONTENIDO Y SOFTWARE EN LA PLATAFORMA TRADEFAN O SERVICIOS.
                    </li>
                    <li>LA FUNCIONALIDAD DE LA PLATAFORMA TRADEFAN O SERVICIOS.</li>
                    <li>MENSAJES O INFORMACIÓN ENVIADOS A TRAVÉS DE LA PLATAFORMA TRADEFAN O POR OTROS USUARIOS.</li>
                    <li>CUALQUIER PRODUCTO O SERVICIO OFRECIDO A TRAVÉS DE LA PLATAFORMA TRADEFAN, INCLUIDOS PRODUCTOS
                        DE TERCEROS.
                    </li>
                    <li>ENLACES A SITIOS WEB O APLICACIONES DE TERCEROS.</li>
                    <li>LA SEGURIDAD DE CUALQUIER INFORMACIÓN SENSIBLE TRANSMITIDA A TRAVÉS DE LA PLATAFORMA TRADEFAN O
                        SERVICIOS,
                        O A SITIOS DE TERCEROS ENLAZADOS A ELLA.
                    </li>
                </ul>
                <p>
                    TRADEFAN NO GARANTIZA QUE LA PLATAFORMA TRADEFAN O SERVICIOS SEAN ININTERRUMPIDOS,
                    LIBRES DE ERRORES, SIEMPRE DISPONIBLES O LIBRES DE VIRUS O ELEMENTOS NOCIVOS, O QUE SE CORREGIRÁN
                    LOS DEFECTOS.
                </p>
                <p>
                    LAS PARTES EXONERADAS DE TRADEFAN NO SON RESPONSABLES DE SI SU USO DE LA PLATAFORMA TRADEFAN O
                    PARTICIPACIÓN EN CONCURSOS ES LEGAL EN SU UBICACIÓN. USTED ES RESPONSABLE DE ASEGURARSE DE QUE SUS
                    ACTIVIDADES SEAN LEGALES DONDE UTILICE LA PLATAFORMA TRADEFAN O SERVICIOS, Y LO HACE BAJO SU PROPIO
                    RIESGO.
                </p>
            </section>
            <section id="indemnification">
                <p><strong>INDEMNIZACIÓN</strong></p>
                <p>
                    Al utilizar la Plataforma TradeFan, participar en un Concurso, utilizar los Servicios o aceptar
                    cualquier premio, acepta indemnizar, liberar y eximir de responsabilidad a las Partes Exoneradas de
                    TradeFan de cualquier responsabilidad, reclamos, daños, pérdidas, costos o gastos (incluidos los
                    honorarios de abogados, costos judiciales y gastos legales) resultantes de: (i) su participación en
                    Concursos o uso de los Servicios o la Plataforma TradeFan, incluidos viajes a o participación en
                    eventos o actividades relacionadas con la Plataforma TradeFan; (ii) su recepción, propiedad, uso o
                    mal uso de cualquier premio, y su asistencia o la de sus invitados a cualquier evento de premio,
                    incluidos los viajes hacia o desde dichos eventos; (iii) su incumplimiento de los Acuerdos; (iv) su
                    uso de los Servicios o la Plataforma TradeFan en violación de cualquier ley o regulación; (v)
                    cualquier financiación de su Cuenta, incluido el método de pago utilizado; (vi) su uso de la
                    Plataforma TradeFan, Servicios o Propiedad Intelectual de una manera que viole o infrinja los
                    derechos de terceros, incluidos patentes, derechos de autor, marcas registradas, derechos de
                    publicidad o derechos de privacidad; (vii) sus derechos de publicidad o privacidad; y (viii)
                    cualquier información que envíe a TradeFan, incluida información falsa o engañosa o
                    tergiversaciones.
                </p>
                <p>
                    Estos se denominan “Reclamos de Indemnización”. TradeFan se reserva el derecho de controlar la
                    defensa o liquidación de cualquier Reclamo de Indemnización sin su consentimiento. Acepta cooperar y
                    proporcionar cualquier información o asistencia solicitada por TradeFan durante la defensa o
                    liquidación
                    de estos reclamos. También acepta no resolver ningún Reclamo de Indemnización ni hacer ninguna
                    declaración que
                    pueda afectar la defensa de TradeFan sin su consentimiento previo por escrito.
                </p>
            </section>
            <br/>
            <section id="limitationLiability">
                <p><strong>LIMITACIÓN DE RESPONSABILIDAD</strong></p>
                <p>USTED ENTIENDE Y ACEPTA QUE LAS PARTES EXONERADAS DE TRADEFAN LIMITAN SU RESPONSABILIDAD POR SU
                    PARTICIPACIÓN EN CONCURSOS O USO DE LOS SERVICIOS Y PLATAFORMA TRADEFAN, INDEPENDIENTEMENTE DE SI EL
                    PROBLEMA SE DEBE A UN CONTRATO, NEGLIGENCIA, RESPONSABILIDAD ESTRICTA O AGRAVIO (INCLUIDOS CAUSAS
                    COMO
                    NEGLIGENCIA, ACTOS DE DIOS, FALLAS DE TELECOMUNICACIONES O ROBO). LAS PARTES EXONERADAS DE TRADEFAN
                    NO
                    SON RESPONSABLES DE NINGUNA PÉRDIDA O DAÑO DE NINGÚN TIPO, INCLUIDOS DAÑOS ESPECIALES, DIRECTOS,
                    INDIRECTOS, INCIDENTALES O PUNITIVOS, QUE ESTÉN RELACIONADOS CON:
                </p>
                <ol>
                    <li>LA PLATAFORMA TRADEFAN, SERVICIOS, CONCURSOS, PROPIEDAD INTELECTUAL O CUALQUIER CONTENIDO EN LA
                        PLATAFORMA TRADEFAN.
                    </li>
                    <li>EL USO, INCAPACIDAD DE USAR O RENDIMIENTO DE LOS SERVICIOS O PLATAFORMA, INCLUIDOS LOS
                        CONCURSOS.
                    </li>
                    <li>CUALQUIER ACCIÓN TOMADA POR TRADEFAN O LAS AUTORIDADES LEGALES EN RELACIÓN CON SU PARTICIPACIÓN
                        EN CONCURSOS O USO
                        DE LA PLATAFORMA O SERVICIOS DE TRADEFAN.
                    </li>
                    <li>ACCIONES TOMADAS EN RELACIÓN CON RECLAMACIONES DE DERECHOS DE AUTOR.</li>
                    <li>CUALQUIER ERROR O PROBLEMA EN LOS CONCURSOS O LA OPERACIÓN TÉCNICA DE LA PLATAFORMA O SERVICIOS
                        DE TRADEFAN.
                    </li>
                </ol>
                <p>
                    INCLUSO SI ESTOS DAÑOS FUERON PREVISIBLES O SE ADVIERTE A LAS PARTES EXONERADAS DE TRADEFAN SOBRE LA
                    POSIBILIDAD
                    DE DICHOS DAÑOS, NO SON RESPONSABLES. ALGUNOS ESTADOS PUEDEN NO PERMITIR ESTA LIMITACIÓN DE DAÑOS,
                    POR
                    LO QUE PUEDE NO APLICARSE A USTED. EN CUALQUIER CASO, LA RESPONSABILIDAD MÁXIMA DE LAS PARTES
                    EXONERADAS DE TRADEFAN PARA TODOS
                    LOS RECLAMOS NO EXCEDERÁ LOS $100.
                </p>
                <p>
                    TAMBIÉN ACEPTA RENUNCIAR A SU DERECHO A UN JUICIO CON JURADO POR CUALQUIER RECLAMO.
                </p>
                <p>
                    SI NO ESTÁ SATISFECHO CON LA PLATAFORMA O LOS SERVICIOS DE TRADEFAN, SU ÚNICA OPCIÓN ES DEJAR DE
                    USARLOS.
                    SI SUFRE DAÑOS O PÉRDIDAS DEBIDO A LAS ACCIONES DE LAS PARTES EXONERADAS DE TRADEFAN, NO SON LO
                    SUFICIENTEMENTE GRAVES COMO PARA JUSTIFICAR QUE SE IMPIDA A TRADEFAN CONTINUAR CON SUS OPERACIONES
                    COMERCIALES, INCLUIDO CUALQUIER DESARROLLO, PRODUCCIÓN O DISTRIBUCIÓN DE SUS SERVICIOS O PRODUCTOS.
                </p>
                <p>
                    AL PARTICIPAR EN CONCURSOS O UTILIZAR LA PLATAFORMA O SERVICIOS DE TRADEFAN, ENTIENDE QUE PUEDE
                    ESTAR RENUNCIANDO A DERECHOS RELACIONADOS CON RECLAMOS QUE ACTUALMENTE DESCONOCE. ACEPTA RENUNCIAR A
                    LOS BENEFICIOS DE CUALQUIER
                    LEY (COMO LA SECCIÓN 1542 DEL CÓDIGO CIVIL DE CALIFORNIA O CUALQUIER LEY, CÓDIGO, ESTATUTO Y/O
                    REGULACIÓN SIMILAR O EQUIVALENTE EN OTRO(S) ESTADO(S)) QUE PODRÍA LIMITAR SU RENUNCIA A DICHOS
                    RECLAMOS.
                </p>
            </section>
            <br/>
            <section id="intellectualPropertyRights">
                <p><strong>DERECHOS DE PROPIEDAD INTELECTUAL</strong></p>
                <p>
                    La Plataforma TradeFan, los Servicios y todo el contenido en ellos, como texto, software, datos,
                    gráficos,
                    fotos, videos, diseños y marcas comerciales (denominados “<strong>Propiedad Intelectual</strong>”),
                    son propiedad de o
                    están licenciados a TradeFan y están protegidos por leyes de EE.UU. e internacionales. TradeFan le
                    otorga un derecho limitado,
                    intransferible, revocable y no exclusivo para utilizar la Plataforma TradeFan, los Servicios y la
                    Propiedad Intelectual para uso personal, no comercial solamente. No puede copiar, reproducir,
                    distribuir,
                    mostrar, vender o modificar ninguna de esta Propiedad Intelectual sin el permiso previo por escrito
                    de TradeFan.
                </p>
                <p>
                    Tiene prohibido la ingeniería inversa, modificación o intento de acceso al código fuente de la
                    Plataforma o Servicios de TradeFan. No puede eliminar ni alterar ningún derecho de autor, marcas
                    comerciales o avisos legales en la Plataforma TradeFan. TradeFan se reserva todos los derechos no
                    otorgados explícitamente a usted y puede
                    terminar su uso de su Propiedad Intelectual en cualquier momento, por cualquier razón. Además, no
                    debe
                    interferir con ninguna característica que impida el uso o copia no autorizada de la Propiedad
                    Intelectual de TradeFan.
                </p>
            </section>
            <br/>
            <section id="jurisdictionAndGoverningLaw">
                <p><strong>JURISDICCIÓN Y LEY APLICABLE</strong></p>
                <p>
                    Si tiene alguna pregunta, inquietud o queja relacionada con la Plataforma TradeFan o los Servicios,
                    envíe un correo electrónico al soporte al cliente de TradeFan a <a
                    href='mailto:support@TradeFan.com'>support@TradeFan.com</a>. Usted acepta hacer esfuerzos razonables
                    de buena fe para resolver cualquier disputa, reclamo o controversia con TradeFan a través de su
                    servicio de atención al cliente antes de emprender acciones legales.
                </p>
                <p>
                    Los Acuerdos se regirán por las leyes sustantivas internas de Quebec, Canadá, sin
                    referencia a sus principios de conflicto de leyes ni a ninguna otra ley que requiera la aplicación
                    de las leyes
                    de una jurisdicción diferente. La jurisdicción exclusiva y el lugar para cualquier disputa, reclamo,
                    causa
                    de acción o controversia relacionada con los Acuerdos, o el uso de la Plataforma TradeFan o los
                    Servicios
                    ("Reclamos") serán los tribunales de jurisdicción competente ubicados en Quebec, Canadá (el
                    "Foro"). Renuncia irrevocablemente a cualquier argumento de que estos tribunales carecen de
                    jurisdicción personal o de que este Foro es inconveniente o inapropiado. Si inicia un procedimiento
                    en una jurisdicción diferente, acepta que TradeFan recuperará de usted los honorarios de abogados y
                    gastos
                    razonablemente incurridos para hacer cumplir este acuerdo de Foro. Además, renuncia a cualquier
                    derecho a un juicio
                    con jurado por cualquier Reclamo.
                </p>
                <p>
                    Usted acepta, en la máxima medida permitida por la ley aplicable, que cualquier y todos los Reclamos
                    que tenga deben
                    iniciarse dentro de un (1) año a partir de la fecha en que se acumule la causa de acción para dicho
                    Reclamo, o
                    renunciará irrevocablemente a dicho Reclamo y estará para siempre excluido de presentar dicho
                    Reclamo.
                </p>
            </section>
            <br/>
            <section id="miscellaneous">
                <p><strong>DISPOSICIONES VARIAS</strong></p>
                <p>
                    Nada en los Acuerdos otorga ningún derecho o beneficio a terceros, a menos que se indique
                    específicamente.
                </p>
                <p>
                    No puede transferir ni ceder sus derechos bajo los Acuerdos, incluida su Cuenta, a cualquier
                    otra persona sin obtener el consentimiento por escrito de TradeFan. Sin embargo, TradeFan puede
                    transferir o ceder los
                    Acuerdos, su Cuenta o sus derechos y obligaciones a cualquier afiliado o tercero sin su
                    consentimiento ni notificación.
                </p>
                <p>
                    La Plataforma TradeFan o los Servicios pueden enlazar a sitios web de terceros, pero TradeFan no
                    tiene control sobre
                    esos sitios y no es responsable de su contenido, políticas de privacidad o prácticas. TradeFan
                    tampoco editará ni controlará el contenido de esos sitios. Al utilizar la Plataforma TradeFan o
                    participar en Concursos,
                    libera a las Partes Exoneradas de TradeFan de cualquier responsabilidad relacionada con su uso de
                    sitios web de terceros. TradeFan le aconseja revisar los términos y políticas de los sitios de
                    terceros que visite, ya que los utiliza bajo su propio riesgo.
                </p>
                <p>
                    También puede haber anuncios de terceros en la Plataforma TradeFan, pero TradeFan no respalda ni
                    garantiza ninguno de esos productos o servicios. Usted es responsable de cualquier trato que tenga
                    con
                    anunciantes externos, y TradeFan no será responsable de ninguna pérdida o daño derivado de esas
                    interacciones. Usted acepta indemnizar y eximir de responsabilidad a las Partes Exoneradas de
                    TradeFan de cualquier reclamo
                    o responsabilidad que surja de su uso de productos o servicios de terceros anunciados en la
                    Plataforma TradeFan.
                </p>
                <p>
                    Nada en los Acuerdos establece una sociedad o empresa conjunta entre usted y TradeFan.
                </p>
                <p>
                    Los editores en línea de terceros que refieren usuarios a la Plataforma TradeFan tampoco son
                    responsables del
                    contenido o servicios de la Plataforma TradeFan. También acepta indemnizar a las Partes Exoneradas
                    de TradeFan
                    de cualquier responsabilidad o reclamos relacionados con estos editores de terceros.
                </p>
                <p>
                    Cualquier renuncia a un término debe hacerse por escrito, y una renuncia no implica renuncias
                    futuras. Si
                    alguna parte de los Acuerdos se considera inválida, el resto seguirá siendo exigible.
                </p>
                <p>
                    TradeFan puede modificar los Acuerdos en cualquier momento sin previo aviso, y es su responsabilidad
                    verificar las actualizaciones. El uso continuado de la Plataforma TradeFan significa que acepta
                    cualquier cambio. Si no está de acuerdo con algún cambio, debe cerrar su cuenta.
                </p>
                <p>
                    TradeFan no será responsable por no cumplir con ninguna obligación bajo los Acuerdos si se debe a
                    causas fuera de su control, como desastres naturales, guerra, pandemias u otras emergencias.
                </p>
                <p>
                    Finalmente, el uso de los Servicios en su dispositivo inalámbrico puede resultar en cargos por datos
                    de su operador,
                    que usted es responsable de pagar.
                </p>
            </section>
            <br/>

            <h1>¿DÓNDE PUEDES JUGAR TRADEFAN PICKX?</h1>
            <h2>TradeFan PickX está disponible en los siguientes estados de EE.UU. y provincias / territorios de
                Canadá:</h2>
            <br/>
            <PickXProvincesAndTerritories/>
        </div>

    );
}

export default TermsOfUseEs;